import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个分销商品类型。
 * @enum
 * @version 1.0.0
 */
enum disGoodsType
{
    /**
     * 体检。
     * @member
     */
    physical = 1,

    /**
     * 口腔
     * @member
     */
    oralCavity,

    /**
     * 绿色就医
     * @member
     */
    greenMedical,

    /**
     * 私立医院
     * @member
     */
    private,

    /**
     * 眼科
     * @member
     */
    ophthalmology,

    /**
     * 陪诊
     * @member
     */
    escort,

    /**
     * 基因
     * @member
     */
    gene,

    /**
     * 实物商品
     * @member
     */
    goods =9
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(disGoodsType,
{
    physical:
    {
        alias: "体检",
        description: ""
    },
    oralCavity:
    {
        alias: "口腔",
        description: ""
    },
    greenMedical:
    {
        alias: "绿色就医",
        description: ""
    },
    ophthalmology:
    {
        alias: "眼科",
        description: ""
    },
    escort:
    {
        alias: "陪诊",
        description: ""
    },
    gene:
    {
        alias: "基因",
        description: ""
    },
    goods:
    {
        alias: "实物商品",
        description: ""
    }
});

export default disGoodsType;
